/**
 * Sidebar Footer
 *
 * @since 1.0.0
 */

export { SidebarFooter } from './component';
export type { SidebarFooterProps } from './types';

